import { ClassAndClassCode } from "./CalendarModels";

export class CalendarFilter {

    ClassesValues: string[];
    // ClassesCodesValues: string[];
    ClassAndCode: ClassAndClassCode[];
    ClassificationValues: string[];
    Afternoon: number;
    Camp: string;

    clearFilter: boolean;

    constructor() {
        this.ClassesValues = [];
        // this.ClassesCodesValues = [];
        this.ClassAndCode = [];
        this.ClassificationValues = [];
        this.Afternoon = -1;
        this.Camp = "";
        this.clearFilter = true;
    }
}